// extracted by mini-css-extract-plugin
export default {"layerSpinner":"loadingSpinner_layerSpinner__bZGsQ","spinner":"loadingSpinner_spinner__W4CMI"};